import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@material-ui/lab';
import { Block, Typography } from '@klp/design';
import type { ISoProsjektDto } from '../../../services/types';

interface SuperOfficeProsjektSelectNotFoundAlertProps {
    searchTerm: string;
    isLoading: boolean;
    data?: Array<ISoProsjektDto>;
}

export const SuperOfficeProsjektSelectNotFoundAlert: React.FC<
    SuperOfficeProsjektSelectNotFoundAlertProps
> = ({ searchTerm, isLoading, data }) => {
    const { t } = useTranslation();
    // Guard: Don't show if search term is too short
    if (searchTerm.length <= 2) {
        return null;
    }

    // Guard: Don't show while loading
    if (isLoading) {
        return null;
    }

    // Guard: Don't show if we don't have data yet or if there are results
    if (!data || data.length > 0) {
        return null;
    }

    return (
        <Block paddingVertical="tiny">
            <Alert severity="warning">
                <Typography>
                    {t('project.opprettProsjekt.prosjekterNotFound')}
                </Typography>
            </Alert>
        </Block>
    );
};
